import { CopyValue } from 'components/CopyValue';
import { ColumnsSectionContainer, SectionColumn, SectionContainer } from 'components/DetailsView/Section';
import { DeliveryState, WarehouseDeliveryFragmentFragment } from 'data/__generated__';
import { DetailFormDatePicker, DetailLink, DetailValue } from 'components/DetailsView';
import { dateFromString, formatDateAsAnniversary, getExtendedFormattedDatetime } from 'helpers/dateTimes';
import { StatusTag } from './StatusTag';
import { useFormContext } from 'react-hook-form';
import { WarehouseDeliveryNote } from '../components/WarehouseDeliveryNote';

export const GeneralInfoSection = ({ warehouseDelivery }: { warehouseDelivery: WarehouseDeliveryFragmentFragment }) => {
    const {
        _id: warehouseDeliveryId,
        createdAt,
        updatedAt,
        siteId,
        site: { name: siteName },
        deliveryDate,
        warehouseColumnId,
        warehouseColumn: { name: warehouseColumnName },
        operatorName,
        stockTransferId,
        state,
    } = warehouseDelivery;

    const { control } = useFormContext();

    return (
        <SectionContainer title="Informations générales" isInitiallyOpen>
            <ColumnsSectionContainer numberOfColumns={3}>
                <SectionColumn>
                    <CopyValue value={warehouseDeliveryId} />
                    <DetailLink
                        path="stock-transfer"
                        name={warehouseDelivery.site.name}
                        label="Transfert de stock"
                        value={stockTransferId}
                    />
                    <DetailLink
                        value={warehouseColumnId}
                        path="site"
                        label="Entrepôt d'origine"
                        name={warehouseColumnName}
                    />
                    <DetailLink path="site" label="Site de destination" name={siteName} value={siteId} />
                </SectionColumn>
                <SectionColumn>
                    <DetailFormDatePicker
                        label="Date de livraison"
                        defaultValue={deliveryDate}
                        name="deliveryDate"
                        control={control}
                        disabled={
                            ![
                                DeliveryState.Created,
                                DeliveryState.Packaging,
                                DeliveryState.Paused,
                                DeliveryState.Ready,
                                DeliveryState.NotDelivered,
                            ].includes(state)
                        }
                        transformValueToDate={(value) => (value ? dateFromString(value, true) : null)}
                        transformDateToValue={(date) =>
                            date ? formatDateAsAnniversary({ dateTime: date, useNewFormat: true }) : null
                        }
                    />
                    <DetailValue label="Operateur" value={operatorName} />
                    <StatusTag state={state} showHeading />
                </SectionColumn>
                <SectionColumn>
                    <DetailValue label="Date de création" value={getExtendedFormattedDatetime(createdAt)} />
                    <DetailValue label="Dernière mise à jour" value={getExtendedFormattedDatetime(updatedAt)} />
                    <WarehouseDeliveryNote warehouseDelivery={warehouseDelivery} />
                </SectionColumn>
            </ColumnsSectionContainer>
        </SectionContainer>
    );
};
